module.exports = __webpack_public_path__ + "static/media/bc_day.e2c25d59.hdr";